module.exports = __webpack_public_path__ + "img/hair_front_female_pulled_back.208c9fc0.png";